import { Check } from "@phosphor-icons/react";
import type { PickerItemProps } from "../../types/PickerTypes";

/**
 * CustomTagsItem - Multi-select tag picker item
 *
 * Renders a selectable tag button with:
 * - Toggle selection (multi-select)
 * - Visual feedback (checkmark for selected)
 * - Searchable text
 * - Supports both string and object formats
 */
export const CustomTagsItem = ({ item, isSelected, onSelect }: PickerItemProps<string | {value: string, label: string}>) => {
  // Handle both string and object formats
  const displayText = typeof item === 'string' ? item : item.label;
  const value = typeof item === 'string' ? item : item.value;

  return (
    <button
      onClick={() => onSelect(value)}
      className={`w-full text-left px-3 py-2 rounded-md text-sm transition-colors ${
        isSelected
          ? 'bg-moss-primary text-white'
          : 'bg-neutral-primary/5 text-neutral-primary hover:bg-neutral-primary/10'
      }`}
    >
      <div className="flex items-center justify-between">
        <span>{displayText}</span>
        {isSelected && <Check className="w-4 h-4" weight="bold" />}
      </div>
    </button>
  );
};
